import React from "react";
import { Checkbox } from "./Checkbox";
import { Field } from "./Field";
import { Label } from "./Label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./Select";

export const PRIVACY_OPTIONS = [
  "Private",
  "Contribute anonymously to CarpIntel statistics",
  "Shared",
] as const;
export type PrivacySetting = (typeof PRIVACY_OPTIONS)[number];

export function PrivacyFields({
  idPrefix,
  privacy,
  onPrivacyChange,
  sharePeg,
  onSharePegChange,
}: {
  idPrefix: string;
  privacy: string;
  onPrivacyChange: (value: string) => void;
  sharePeg: boolean;
  onSharePegChange: (value: boolean) => void;
}) {
  const description =
    privacy === "Private"
      ? "Only you can see the exact record. It is left out of community statistics."
      : privacy === "Shared"
        ? "Other anglers can see this record on Shared. Community statistics still never show exact spots, GPS, notes or photos."
        : "Exact details stay private. Safe anonymous fields can help CarpIntel statistics.";
  return (
    <div className="space-y-4">
      <Field
        label="Privacy setting"
        id={`${idPrefix}-privacy`}
        help={description}
      >
        <Select value={privacy} onValueChange={onPrivacyChange}>
          <SelectTrigger id={`${idPrefix}-privacy`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PRIVACY_OPTIONS.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>
      <div className="flex items-start gap-3">
        <Checkbox
          id={`${idPrefix}-share-peg`}
          checked={sharePeg}
          onCheckedChange={(checked) => onSharePegChange(checked === true)}
        />
        <div className="min-w-0">
          <Label
            htmlFor={`${idPrefix}-share-peg`}
            className="text-sm font-medium text-primary"
          >
            Allow peg or swim in anonymous statistics
          </Label>
          <p className="mt-1 text-xs text-secondary">
            Off by default. Fishing spots, GPS, private notes and photos are
            never included.
          </p>
        </div>
      </div>
    </div>
  );
}
